import React, {useRef, useState} from 'react';
import reviewRating from '../../assets/images/review-rating.svg'
import matthewSavouryImage from '../../assets/images/matthew_savoury-2020-2.jpeg'
import leslieHImage from '../../assets/images/leslie-h-2020-41.jpeg'
import iphoneImage from '../../assets/images/iPhone.png'
import playButton from '../../assets/images/play-button.svg'
// import tikTokVideoOne from '../../assets/images/tiktok-video-embed.mp4'
import "./TiktokSection.css"
import "./Modal.css"
// import { TikTokEmbed } from 'react-social-media-embed';
// import iphoneBack from '../../assets/images/iphone-image-bg.png'

const TiktokSection = () => {

const [videoPlaying, setVideoPlaying] = useState("");
const [modalClass, setModalClass] = useState("");

//function to toggle between .modal and 

const videoRef = useRef(null);

        const playVideo = () => {
                videoRef.current.play();
        }

        const pauseVideo = () => {
        console.log("Pause Video");
        }


        const openModal = async () => {
                await new Promise(
                 resolve => {
                        setModalClass("show-modal");
                        resolve();
                 }
                );
                videoRef.current.play();
        }

        const closeModal = async () => {
                await new Promise(
                        resolve => {
                                videoRef.current.pause();
                                resolve();
                        }
                );
                setModalClass("");
        }


//add event listeners to check for click events










// trigger.addEventListener("click", toggleModal);
// closeButton.addEventListener("click", toggleModal);
// window.addEventListener("click", windowOnClick); 





return (

<>
     
    <div className='uk-section trip-background-moss' uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-medium; delay: 200; offset-top: 50; repeat: true;">
        <div className='uk-container'>


                        {/* 
                        <div className='phone-container'>
                        <div className='phone-case'>
                                <img src={iphoneBack} alt="iphone background" className='iphone-image'/>

                                <span>
                        <TikTokEmbed url={tikTokVideo} style={{borderRadius: "32px"}} />
                                </span> */}
                                {/* <video>
                                        
                                        <source src={tikTokVideoOne} type="video/mp4" controls/>
                                </video> */}

                        {/* </div>
                        </div> */}




                <div className="tm-grid-expand uk-grid-margin uk-grid" uk-grid="" >

                                <div className="uk-width-1-2@m uk-first-column" uk-scrollspy-class="uk-animation-slide-bottom-medium">
                                        <div className='trip-heading-display trip-ultra trip-white uk-margin-large-bottom' > 
                                        And showed love to the tour guides who shared their secrets and made us feel at home.
                                        </div>              
                                </div>

                                <div className="uk-width-1-2@m">
                                

                                
                                </div>
                </div>


                 {/* Desktop view */}
                <div className="tm-grid-expand uk-child-width-1-1 uk-grid-margin uk-grid uk-grid-stack uk-visible@s" uk-scrollspy-class="uk-animation-slide-bottom-medium">
                        <div className="uk-grid-item-match uk-flex-bottom uk-width-1-1 uk-first-column">
                                <div className="uk-panel uk-width-1-1">            

                                        <div className="uk-margin uk-slider uk-slider-container" tabIndex="-1" uk-slider="autoplay: false; pauseOnHover: true;">
                                        <div className="uk-position-relative uk-flex uk-flex-bottom height-force ">
                                                
                                                <ul className="uk-slider-items uk-grid uk-flex uk-flex-middle" style={{transform: "translate3d(-323.867px, 0px, 0px)"}}>

                                                        <li className='uk-width-1-1 uk-width-1-2@m uk-margin-auto'>

                                                                <div className='uk-card uk-card-border tiktok-slim-review-container'>

                                                                        <div className='forum-slim-rating'>
                                                                                <img src={reviewRating} alt="Star Rating" className=''/>
                                                                        </div>

                                                                        <div className='tiktok-slim-content'>
                                                                        Thank you to Brian, Bryan, and ALL of the lovely and kind people that made our honeymoon so magical and easy…I honestly cannot wait to go back and see more monkeys, macaws, and Brian!


                                                                        </div>

                                                                        <div className="uk-flex uk-flex-middle forum-slim-user-info">
                                                                                <div className="uk-margin-small-left forum-slim-review-user">
                                                                                @Matthew_Savoury
                                                                                </div>
                                                                                <div className=" uk-flex-first">
                                                                                <img src={matthewSavouryImage} alt="User Avatar" className='forum-slim-avatar'/>
                                                                                </div>
                                                                        </div>
                                                                                
                                                                        <div className='forum-slim-review-footer'>
                                                                        Review of Tulemar Bungalows & Villas
                                                                        </div>

                                                                </div>
                                                        
                                                        </li>


                                                        <li className="uk-width-1-1 uk-width-1-2@m gallery uk-margin-auto" >
                                                                
                                                                <div className='phone-container'>
                                                                        <div className='iphone-holder'>
                                                                        <img src={iphoneImage} alt="iphone background" className='iphone-image'/>
                                                                        <div className="uk-position-center uk-margin-left">
                                                                        <span>
                                                                        <button className="clear-button" onClick={openModal}> 
                                                                        <img  src={playButton} alt="Play Button" className='play-button'/> </button>
                                                                        </span> 
                                                                        </div>
                                                                        </div>
                                                                </div>
                                                                
                                                                {/* <div className='phone-container uk-visible@s' >
                                                                        <div className='phone-case'>
                                                                                <img src={iphoneBack} alt="iphone background" className='iphone-image'/>

                                                                                <span>
                                                                        <TikTokEmbed url={tikTokVideo} style={{borderRadius: "32px"}} />
                                                                                </span>


                                                                        </div>
                                                                </div>

                                                                <div className='uk-hidden@s'>
                                                                <TikTokEmbed url={tikTokVideo} style={{borderRadius: "32px"}} width="325px"/>
                                                                </div> */}


                                                
                                                        </li>                                


                                                        <li className="uk-width-1-1 uk-width-1-2@m gallery uk-margin-auto">
                                                        <div className='uk-card uk-card-border tiktok-slim-review-container'>

                                                                <div className='forum-slim-rating'>
                                                                        <img src={reviewRating} alt="Star Rating" className=''/>
                                                                </div>

                                                                <div className='tiktok-slim-content'>
                                                                Yamille is fantastic. She shares her love of the land with genuine enthusiasm and makes swimming 
                                                                in caves with bats flying overhead and jumping off cliffs feel both exciting and safe.
                                                                </div>

                                                                <div className="uk-flex uk-flex-middle forum-slim-user-info">
                                                                        <div className="uk-margin-small-left forum-slim-review-user">
                                                                        @leslieh233
                                                                        </div>
                                                                        <div className=" uk-flex-first">
                                                                        <img src={leslieHImage} alt="User Avatar" className='forum-slim-avatar'/>
                                                                        </div>
                                                                </div>
                                                                        
                                                                <div className='forum-slim-review-footer'>
                                                                Review of Arenales Caves and River Adventure in Puerto Rico
                                                                </div>

                                                        </div>
                                                        </li>                            
                                                </ul> 
                                                
                                        </div>
                                        <ul className="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>
                                        </div>

                                </div>
                
                
        
 

                        </div>
                </div>


                {/* Mobile View */}
                <div className='uk-hidden@s' uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-small; delay: 600; offset-top: 100; repeat: true;" >



                        <div className=''>
                                <div className='uk-flex uk-flex-center'>
                                        <div className='uk-card uk-card-border tiktok-slim-review-container' uk-scrollspy-class="uk-animation-slide-bottom-medium">

                                                <div className='forum-slim-rating'>
                                                        <img src={reviewRating} alt="Star Rating" className=''/>
                                                </div>

                                                <div className='tiktok-slim-content'>
                                                Thank you to Brian, Bryan, and ALL of the lovely and kind people that made our honeymoon so magical and easy…I honestly cannot wait to go back and see more monkeys, macaws, and Brian!
                                                </div>

                                                <div className="uk-flex uk-flex-middle forum-slim-user-info">
                                                        <div className="uk-margin-small-left forum-slim-review-user">
                                                        @Matthew_Savoury
                                                        </div>
                                                        <div className=" uk-flex-first">
                                                        <img src={matthewSavouryImage} alt="User Avatar" className='forum-slim-avatar'/>
                                                        </div>
                                                </div>
                                                        
                                                <div className='forum-slim-review-footer'>
                                                Review of Tulemar Bungalows & Villas
                                                </div>

                                        </div>
                                </div>

                        </div>

                        <div className='forum-margin-top '>
                                <div className='uk-flex uk-flex-center uk-flex-middle uk-flex-column uk-position-relative' uk-scrollspy-class="uk-animation-slide-bottom-medium">

                                <img src={iphoneImage} alt="iphone background" className='iphone-image'/>
                                <div className='play-button-center'>
                                <button className="clear-button" onClick={openModal}>  <img  src={playButton} alt="Play Button" className='play-button'/> </button>
                                </div> 
                                </div>

                                
                        </div>

                        <div className='forum-margin-top '>

                                        <div className='uk-card uk-card-border tiktok-slim-review-container' uk-scrollspy-class="uk-animation-slide-bottom-medium">

                                <div className='forum-slim-rating'>
                                        <img src={reviewRating} alt="Star Rating" className=''/>
                                </div>

                                <div className='tiktok-slim-content'>
                                Yamille is fantastic. She shares her love of the land with genuine enthusiasm and makes swimming 
                                in caves with bats flying overhead and jumping off cliffs feel both exciting and safe.
                                </div>

                                <div className="uk-flex uk-flex-middle forum-slim-user-info">
                                        <div className="uk-margin-small-left forum-slim-review-user">
                                        @leslieh233
                                        </div>
                                        <div className=" uk-flex-first">
                                        <img src={leslieHImage} alt="User Avatar" className='forum-slim-avatar'/>
                                        </div>
                                </div>
                                        
                                <div className='forum-slim-review-footer'>
                                Review of Arenales Caves and River Adventure in Puerto Rico
                                </div>

                </div>


                        </div>



                </div>

                                                                       {/* New Modal Here */}

                                                                       <div className={`modal ${modalClass}`}>
                                                                <div className='modal-content'>

                                                                <span className='close-button' onClick={ closeModal }> <span uk-icon="close"></span> </span>

                                                                <div>
                                                                <video ref={videoRef}  width="450" height="auto" controls className='border-round'>
                                                                        <source src="https://taunpacked.entropico.tech/media/tiktok-video-embed.mp4" type="video/mp4" />
                                                                        Your browser does not support the video tag.
                                                                </video>
                                                                </div>



                                                                </div>
                                                        </div>


        </div>
    </div>







</>
  )
}

export default TiktokSection